/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import SandboxEchoPageQuery, {
	type SandboxEchoPageQuery as QueryType,
} from './ui/__generated__/SandboxEchoPageQuery.graphql';

type Queries = {
	pageQueryRef: QueryType;
};

type SandboxEchoPageEntryPointComponent = EntryPointComponent<
	Queries, // AdditionalEntryPointsToLoad
	{}, // ComponentProps,
	{}, // ExtraProps
	{}
>;

export const sandboxEchoPageEntryPoint: EntryPoint<
	SandboxEchoPageEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SandboxEchoPageEntryPointComponent>(
		/* webpackChunkName: "async-sandbox-echo-page", jiraSpaEntry: "jira-spa-sandboxdemo" */ './ui/SandboxEchoPage.tsx',
	),
	getPreloadProps: ({ tenantContext, context: routerContext }: EntryPointRouteParams) => {
		return {
			queries: {
				pageQueryRef: {
					parameters: SandboxEchoPageQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						enableDefer: Boolean(
							'defer' in routerContext.query ? routerContext.query.defer === 'true' : true,
						),
						skipLongQuery: Boolean(
							'skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true,
						),
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
		};
	},
});
